export const PROFILE_COMPARISON_GRID_LIMIT = 20;
